import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Navbar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useSeo } from "../lib/seo";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    useSeo({ title: "Sign in", description: "Sign in to Sift to see where your money went.", path: "/login" });
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Welcome back!");
            navigate("/dashboard");
        } else {
            toast.error(res.error);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4 py-12" data-testid="login-page">
            <div className="w-full max-w-md">
                <div className="mb-8 flex justify-center"><Logo /></div>
                <div className="rounded-2xl border border-border bg-card p-8 shadow-2xl">
                    <h1 className="font-heading text-2xl font-bold text-foreground">Sign in</h1>
                    <p className="mt-1 text-sm text-muted-foreground">Pick up where your money left off.</p>
                    <form onSubmit={submit} className="mt-6 space-y-4">
                        <div>
                            <Label htmlFor="email" className="text-foreground/85">Email</Label>
                            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                                data-testid="login-email-input" className="mt-1.5 bg-secondary border-border" placeholder="you@example.com" />
                        </div>
                        <div>
                            <Label htmlFor="password" className="text-foreground/85">Password</Label>
                            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                                data-testid="login-password-input" className="mt-1.5 bg-secondary border-border" placeholder="••••••••" />
                        </div>
                        <Button type="submit" disabled={loading} data-testid="login-submit-btn"
                            className="w-full bg-primary font-semibold text-primary-foreground hover:bg-primary/90">
                            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
                        </Button>
                    </form>
                    <p className="mt-6 text-center text-sm text-muted-foreground">
                        No account?{" "}
                        <Link to="/register" className="font-semibold text-primary hover:underline" data-testid="to-register-link">Create one</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
